import { gql } from "apollo-boost";

export const fragments = {
  service: gql`
    fragment JobService on Service {
      id
      serviceType
      status
      holdType
      holdReason
      updatedAt
    }
  `
};

export default gql`
  query JobServicesQuery($jobId: ID!) {
    services(jobId: $jobId) {
      ...JobService
    }
  }
  ${fragments.service}
`;



// WEBPACK FOOTER //
// ./src/queries/JobServices.js